import React from 'react';
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Link from "@mui/material/Link";
import { RakutenIcon } from '@rakutenfrance/material-ui-icons';
import { colorPalette } from '../../colorPalette';
import { StyledDiv } from './BoxLink.style';
export const BoxLink = ({ label, url, newWindow, variant, iconColor, icon, margins }) => {
    let target;
    if (newWindow) {
        target = '_blank';
    }
    return (React.createElement(Link, { href: url, target: target, underline: "none", "data-qa": "box-link" },
        React.createElement(StyledDiv, { variant: variant, margins: margins },
            React.createElement(Typography, null, label),
            React.createElement(IconButton, { sx: { padding: 0 }, size: "large" },
                React.createElement(RakutenIcon, { icon: icon, fontSize: "small", htmlColor: iconColor && colorPalette[iconColor] }),
                ' '))));
};
